<template>
<div class="diet-options-wrapper">
  <div class="diet-options">
    <BaseCheckboxListItem
      :items="dietPrefs"
      :showSelectAll="true"
      :allowToggleAll="false"
      :allOpt="selectAllOpt"
      :selectMultiple="false"
      :showGradientBorders="false"
      :onTabletUp="this.onTabletUp"
      :validateSelect="true"
      @is-valid="onValidate"
    />
  </div>
  <div class="btn-wrapper">
    <BaseButton type="button" class="btn-large btn-step" @click="save">
      Save
    </BaseButton>
  </div>
</div>
</template>

<script>
import { breakpointsMixin } from 'breakpointsMixin';
import { userComputed, userMethods, kitchenDrawerMethods } from '@state/helpers';

export default {
  mixins: [breakpointsMixin],
  components: {},
  props: {
    onTabletUp: {
      type: Boolean,
    },
  },
  data() {
    return {
      isValid: false,
      selectAllOpt: {
        name: 'No Diet',
        subtitle: 'Show me everything',
        isSelected: false,
      },
    };
  },
  computed: {
    ...userComputed,
    dietPrefs() {
      return this.preferences ? this.preferences.filter((pref) => pref.preferenceCategoryId === 1) : [];
    },
  },
  mounted() {},
  methods: {
    ...kitchenDrawerMethods,
    ...userMethods,
    save() {
      this.updatePreferences({ preferences: this.preferences });
      this.navigateHigher();
    },
    onValidate(evt) {
      this.isValid = evt;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.diet-options-wrapper {
  @extend %scrollable-drawer-content;

  padding: 2rem 2rem 11rem;
  text-align: center;
}
</style>
